var m = require('mithril');
var serviceModel = require('../models/service');

function sortByName(left, right) {
  return String(left && left.name || '').localeCompare(String(right && right.name || ''));
}

function indentedLabel(name, level) {
  return `${Array(level + 1).join('\u00a0\u00a0\u00a0')}${name}`;
}

function addOptions(childrenArray, options, level) {
  level++;
  (childrenArray || []).slice().sort(sortByName).map(category => {
    if (!category || !category.name) return;
    options.push({
      value: category.name,
      label: indentedLabel(category.name, level)
    });
    if (category.children && Array.isArray(category.children)) {
      addOptions(category.children, options, level);
    }
  });
}

function serviceClassOptions() {
  let options = [];
  let level = 0;
  (serviceModel.measurableClassTree.categories || []).slice().sort(sortByName).map(category => {
    if (!category || !category.name || category.name === 'Overview') return;
    options.push({
      value: category.name,
      label: indentedLabel(category.name, level)
    });
    if (category.children && Array.isArray(category.children)) {
      addOptions(category.children, options, level);
    }
  });
  return options;
}

var serviceClassSelect = {
  view: function (vnode) {
    var attrs = vnode.attrs || {};
    var value = attrs.value || '';
    var options = serviceClassOptions();
    var optionValues = new Set(options.map(option => option.value));
    var renderedOptions = [];

    if (attrs.includeBlank) {
      renderedOptions.push(m('option', { value: '' }, attrs.blankLabel || ''));
    }

    if (value && !optionValues.has(value) && attrs.includeLegacy !== false) {
      renderedOptions.push(m('option', { value: value }, `${value} (legacy)`));
    }

    options.forEach(option => {
      renderedOptions.push(m('option', { value: option.value }, option.label));
    });

    var selectAttrs = {
      value: value,
      onchange: function (ev) {
        if (attrs.onchange) attrs.onchange(ev.target.value, ev);
      }
    };

    if (attrs.class !== undefined) {
      selectAttrs.class = attrs.class;
    }

    return m('select', selectAttrs, renderedOptions);
  }
};

module.exports = serviceClassSelect;
